<fieldset id="radio">
  @for (answer of problem_template.answers; track answer) {
    <div class="flex items-center mt-4 p-2 rounded"
         [ngClass]="{'bg-green-100 border border-green-500 text-green-800': answer.correct && showCorrectAnswers}">
      <input
        type="radio"
        [disabled]="review"
        (change)="onSelect(answer.value)"
        [checked]="problem_template.recordedAnswer === answer.value"
        [value]="answer.value"
        [name]="problem_template.question_text"
        [style]="radioStyle"
        [(ngModel)]="recordedAnswer"
      />
      @if (answer.mathjax) {
        <label [mathjax]="answer.formatted"></label>
      } @else if (checkForHTMLTags(answer.formatted)) {
        <label [innerHTML]="answer.formatted"></label>
      } @else {
        <label [innerText]="answer.formatted"></label>
      }
    </div>
  }
</fieldset>
